import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Edit,
  Create,
  SimpleForm,
  TextInput,
  required,
  Show,
  SimpleShowLayout,
  DateField,
  ReferenceField,
  ReferenceInput,
  SearchInput,
  FilterButton,
  CreateButton,
  TopToolbar,
} from "react-admin";
import ExportAllButton from "../components/ExportAllButton";
import DynamicDropdownFilter from "../components/DynamicDropdownFilter";

const ImageSourceFilters = [
  <SearchInput source="q_name_imageRepository_codeRepository" alwaysOn />,
  <DynamicDropdownFilter
    label=" Name"
    source="name"
    resource="cve/image-sources"
  />,
  <DynamicDropdownFilter
    label="Image Repository"
    source="imageRepository"
    resource="cve/image-sources"
  />,
  <DynamicDropdownFilter
    label="Code Repository"
    source="codeRepository"
    resource="cve/image-sources"
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportAllButton />
  </TopToolbar>
);

export const ImageSourceList = (props: any) => (
  <List
    {...props}
    filters={ImageSourceFilters}
    sort={{ field: "name", order: "ASC" }}
    actions={<ListActions />}
  >
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="imageRepository" />
      <TextField source="codeRepository" />
      <TextField source="codeSourceDirectory" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

export const ImageSourceShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="imageRepository" />
      <ReferenceField reference="cve/code-sources" source="codeSource">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="codeSourceDirectory" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

export const ImageSourceEdit = (props: any) => (
  <Edit {...props} redirect="show">
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <TextInput source="imageRepository" validate={required()} />
      <TextInput source="codeRepository" disabled />
      <TextInput source="codeSourceDirectory" />
    </SimpleForm>
  </Edit>
);

export const ImageSourceCreate = (props: any) => (
  <Create {...props} redirect={"show"}>
    <SimpleForm>
      <TextInput source="name" validate={required()} />
      <TextInput source="imageRepository" validate={required()} />
      <ReferenceInput source="codeSource" reference="cve/code-sources" />
      <TextInput source="codeSourceDirectory" />
    </SimpleForm>
  </Create>
);
